// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"wp_a bhu_b bhu_ux"};